import React from 'react'
import { Button, Modal } from 'react-bootstrap'

import Loader from '../../_atoms/Loader/Loader'
import OverlayWithText from '../../_atoms/OverlayWithText/OverlayWithText'
import { formatDate } from '../../../utils/converters'

import styles from './styles.module.scss'

interface Props {
    isOpen: boolean
    closeModal: () => void
    confirmRevert: () => void
    partsCount: number
    operationDate: number
    isLoading?: boolean
}

export const ModalBulkPriceRevertConfirm = ({
    isOpen,
    closeModal,
    confirmRevert,
    partsCount,
    operationDate,
    isLoading,
}: Props) => {
    return (
        <Modal show={isOpen} onHide={closeModal} centered dialogClassName={styles.modal}>
            {isLoading && (
                <OverlayWithText backgroundBootstrapColor={'bg-secondary'}>
                    <Loader diameterInPx={100} thicknessInPx={10} />
                </OverlayWithText>
            )}
            <Modal.Header closeButton>
                <Modal.Title>
                    <b>Отменить изменение цен</b>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Вернуть цены {partsCount} запчастей к значениям до массового изменения от {formatDate(operationDate)}?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeModal} disabled={isLoading}>
                    Отмена
                </Button>
                <Button variant="danger" onClick={confirmRevert} disabled={isLoading}>
                    Отменить изменение цен
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
